import { CONNECTION_SPACING } from '../../Common';
import { FORWARD_Y } from '../boiler/boiler-metadata';
import { LabelPosition, SystemMeta } from '../../types';
import { EConnectionType, SystemType } from '../../../state';
import { EConnectionPointPlacement } from '../../../types';
import thumbnail from '../../../../../assets/system_thumbnails/district-supply-heating.svg';
import { getForwardReturnTempLabels, getHorizontalHeatMeterLabels } from '../../heat-meter-or-sensors/heat-meter-or-sensors-metadata';
import districtHeatingSupplySystemForm from '../../../../models/systems/districtHeatingSupplySystem/districtHeatingSupplySystemForm.json';
import { IDistrictHeatingSupplySystemFormInterface } from '../../../../models/systems/districtHeatingSupplySystem/districtHeatingSupplySystemFormInterface';

export const WIDTH = 180;
export const SUPPLY_X = 26;
export const SUPPLY_Y = 100;
export const RETURN_Y = SUPPLY_Y + CONNECTION_SPACING;
export const HEAT_METER_X = 100;

export const districtHeatingSupplyMeta: SystemMeta = {
  systemType: SystemType.DistrictHeatingSupply,
  name: 'District Supply',
  thumbnail,
  width: WIDTH,
  height: 260,
  form: districtHeatingSupplySystemForm,
  calculateConnectionPoints: () => [
    {
      key: EConnectionPointPlacement.connectionSecondaryForward,
      x: WIDTH,
      y: SUPPLY_Y,
      type: EConnectionType.supply,
      dotted: false,
    },
    {
      key: EConnectionPointPlacement.connectionSecondaryReturn,
      x: WIDTH,
      y: RETURN_Y,
      type: EConnectionType.return,
      dotted: true,
    },
  ],
};

export const getDistrictHeatingLabels = (systemInfo: IDistrictHeatingSupplySystemFormInterface): LabelPosition[] => {
  return [
    ...getForwardReturnTempLabels(HEAT_METER_X, FORWARD_Y, systemInfo),
    ...getHorizontalHeatMeterLabels(HEAT_METER_X, FORWARD_Y, systemInfo),
  ];
};
